module.exports = __webpack_public_path__ + "img/arrow_up_circle.b6c0bba8.svg";